import { AuthSendType } from '../../../Components/Auth/context/context';
import { throttledGetCurrentCredentials } from './getCredentials';

export const getIdentityId = async (send?: AuthSendType) => {
  const { identityId } = await throttledGetCurrentCredentials(send);
  return identityId;
};
